import React, { useEffect, useRef, useState } from 'react';
import '../ds/styles/tramas.css';

/**
 * FondoMosaico — el fondo de GUIA (marca 2026, tramas del 24/10/2026): blanco con la brújula (la A del
 * logo) repetida, rellena y a color, y el agua como segunda trama. La principal es el negativo Orquídea. Las baldosas son las del kit
 * (src/ds/tramas); no se redibuja la A.
 * Cada pantalla de la charla pasa a la trama siguiente: negativo Orquídea → agua → brújula (colores) → agua.
 * Una sola trama a la vez; el cambio es un fundido (sin movimiento con prefers-reduced-motion).
 * Con `avance` (0 a 1) no alterna: queda la trama principal y se va encendiendo en diagonal con cada paso de la
 * charla; en el resultado está completa. Sin `avance` (otras páginas) alterna por pantalla.
 * El texto nunca va sobre el fondo: vive en los paneles blancos (.gh-panel).
 */
const SECUENCIA = ['neg', 'agua', 'colores', 'agua'];

export default function FondoMosaico({ pantalla, avance }) {
  const [paso, setPaso] = useState(0);
  const anterior = useRef(pantalla);

  useEffect(() => {
    if (anterior.current === pantalla) return;
    anterior.current = pantalla;
    setPaso((n) => n + 1);
  }, [pantalla]);

  const conAvance = typeof avance === 'number';
  const activa = conAvance ? 'neg' : SECUENCIA[paso % SECUENCIA.length];
  return (
    <div aria-hidden="true" className="gh-fondo" data-trama={activa} data-avance={conAvance || undefined}>
      {['neg', 'colores', 'agua'].map((t) => (
        <div
          key={t}
          className={`gh-fondo__capa gh-fondo__capa--${t}`}
          data-activa={t === activa}
          style={conAvance && t === 'neg' ? { '--gh-avance': `${Math.round(Math.max(0, Math.min(1, avance)) * 100)}%` } : undefined}
        />
      ))}
    </div>
  );
}
